// PromotionPricingSection.jsx

import React, { useState, useEffect } from "react";
import "./PromotionPricingSection.css";

import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import StarBorderOutlinedIcon from "@mui/icons-material/StarBorderOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import DiamondOutlinedIcon from "@mui/icons-material/DiamondOutlined";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import ViewCarouselOutlinedIcon from "@mui/icons-material/ViewCarouselOutlined";
import Button from "@mui/material/Button";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOffer";
import ShoppingCartCheckoutOutlinedIcon from "@mui/icons-material/ShoppingCartCheckout";
import ParticularsectionBuilder from './ParticularsectionBuilder';
import { Switch, FormControlLabel } from "@mui/material";
import CreateCampaign from "./CreateCampaign.jsx";
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";


const pricingPlans = {
    branding: [
        {
            title: "In-App Popup",
            goal: "branding",
            subGoal: "awareness",
            type: "Promotion",
            icon: <CampaignOutlinedIcon />,
            buttonText: "Create",
            loopsPerDay: 100,        // 👈 NEW
            media: {
                image: { originalPrice: 1499, price: 299, duration: "30 Days", resolution: "1080 × 1080 px", format: "JPG / PNG", maxSize: "5 MB" },
                video: { originalPrice: 2999, price: 599, duration: "30 Days", resolution: "1920 × 1080 px", format: "MP4", maxSize: "50 MB", length: "30 Seconds" }
            },
            features: ["Popup Advertisement", "Image & Video Support", ]
        },
        {
            title: "Banner",
            goal: "branding",
            subGoal: "awareness",
            type: "Display Ads",
            icon: <ViewCarouselOutlinedIcon />,
            buttonText: "Create",
            loopsPerDay: 150,        // 👈 NEW
            media: {
                image: { originalPrice: 1499, price: 899, duration: "30 Days", resolution: "1920 × 600 px", format: "PNG / JPG", maxSize: "5 MB" },
                video: { originalPrice: 1999, price: 1199, duration: "30 Days", resolution: "1720 × 600 px", format: "MP4", maxSize: "50 MB", length: "30 Seconds" }
            },
            features: ["Homepage Banner", "Image & Video Support"]
        },
        {
            title: "Deals",
            goal: "branding",
            subGoal: "awareness",
            type: "Featured Deals",
            popular: true,
            icon: <LocalOfferOutlinedIcon />,
            buttonText: "Create",
            loopsPerDay: 100,        // 👈 NEW
            media: {
                image: { originalPrice: 1999, price: 1199, duration: "30 Days", resolution: "1080 × 1080 px", format: "PNG / JPG", maxSize: "5 MB" },
                video: { originalPrice: 2499, price: 1499, duration: "30 Days", resolution: "1920 × 1080 px", format: "MP4", maxSize: "50 MB", length: "30 Seconds" }
            },
            features: ["Featured Deals", "Image & Video Support"]
        },
        {
            title: "Checkout",
            goal: "branding",
            subGoal: "awareness",
            type: "Checkout Promotion",
            icon: <ShoppingCartCheckoutOutlinedIcon />,
            buttonText: "Create",
            loopsPerDay: 100,        // 👈 NEW
            media: {
                image: { originalPrice: 1299, price: 799, duration: "30 Days", resolution: "1080 × 1080 px", format: "PNG / JPG", maxSize: "5 MB" },
                video: { originalPrice: 1799, price: 1099, duration: "30 Days", resolution: "1920 × 1080 px", format: "MP4", maxSize: "50 MB", length: "30 Seconds" }
            },
            features: ["Checkout Page Promotion", "Image & Video Support"]
        }
    ],

    leads: [
        {
            title: "100 Leads",
            goal: "leads",
            subGoal: "more_leads",
            type: "Lead Generation",
            icon: <CampaignOutlinedIcon />,
            buttonText: "Create",
            loopsPerDay: 100,          // 👈 NEW
            media: {
                image: { originalPrice: 1499, price: 299, duration: "30 Days", resolution: "1080 × 1080 px" },
                video: { originalPrice: 1999, price: 499, duration: "30 Days", resolution: "1920 × 1080 px" }
            },
            features: ["100 Verified Leads", "WhatsApp Leads"]
        },
        {
            title: "200 Leads",
            goal: "leads",
            subGoal: "more_leads",
            type: "Lead Generation",
            popular: true,
            icon: <CampaignOutlinedIcon />,
            buttonText: "Create",
            loopsPerDay: 100,          // 👈 NEW
            media: {
                image: { originalPrice: 2499, price: 499, duration: "30 Days", resolution: "1080 × 1080 px" },
                video: { originalPrice: 2999, price: 799, duration: "30 Days", resolution: "1920 × 1080 px" }
            },
            features: ["200 Verified Leads", "WhatsApp Leads"]
        },
        {
            title: "300 Leads",
            goal: "leads",
            subGoal: "more_leads",
            type: "Lead Generation",
            icon: <CampaignOutlinedIcon />,
            buttonText: "Create",
            loopsPerDay: 100,         // 👈 NEW
            media: {
                image: { originalPrice: 3499, price: 699, duration: "30 Days", resolution: "1080 × 1080 px" },
                video: { originalPrice: 3999, price: 999, duration: "30 Days", resolution: "1920 × 1080 px" }
            },
            features: ["300 Verified Leads", "WhatsApp Leads"]
        }
    ],
    offers: [
        // {
        //     title: "Menu Discounts",
        //     goal: "discount",
        //     subGoal: "menu",
        //     type: "Discount Campaign",
        //     icon: <LocalOfferOutlinedIcon />,
        //     buttonText: "Create",
        //     media: {
        //         image: { originalPrice: 1999, price: 1199, duration: "30 Days", resolution: "1080 × 1080 px", format: "PNG / JPG", maxSize: "5 MB" },
        //         video: { originalPrice: 2499, price: 1499, duration: "30 Days", resolution: "1920 × 1080 px", format: "MP4", maxSize: "50 MB", length: "30 Seconds" }
        //     },
        //     features: ["Flat & Percentage Discounts", "Menu Category Discounts", "Campaign Analytics"]
        // },
        {
            title: "Coupons",
            goal: "discount",
            subGoal: "coupons",
            type: "Coupon Campaign",
            popular: true,
            icon: <StarBorderOutlinedIcon />,
            buttonText: "Create",
            media: {
                image: { originalPrice: 1499, price: 899, duration: "30 Days", resolution: "1080 × 1080 px", format: "PNG / JPG", maxSize: "5 MB" },
                video: { originalPrice: 1999, price: 1199, duration: "30 Days", resolution: "1920 × 1080 px", format: "MP4", maxSize: "50 MB", length: "30 Seconds" }
            },
            features: ["Coupon Code Support", "Limited Time Offers", "Redemption Analytics"]
        },
        // {
        //     title: "Buy 1 Get 1",
        //     goal: "BOGO_DISCOUNT",
        //     subGoal: "menu",
        //     type: "BOGO Campaign",
        //     icon: <WorkspacePremiumOutlinedIcon />,
        //     buttonText: "Create",
        //     media: {
        //         image: { originalPrice: 2499, price: 1499, duration: "30 Days", resolution: "1080 × 1080 px", format: "PNG / JPG", maxSize: "5 MB" },
        //         video: { originalPrice: 2999, price: 1799, duration: "30 Days", resolution: "1920 × 1080 px", format: "MP4", maxSize: "50 MB", length: "30 Seconds" }
        //     },
        //     features: ["Buy 1 Item & Get 1 Free", "Applicable Menu Items", "Campaign Analytics"]
        // },
        // {
        //     title: "Combo Discount",
        //     goal: "Combos",
        //     subGoal: "offers",
        //     type: "Combo Offer",
        //     popular: true,
        //     icon: <LocalMallOutlinedIcon />,
        //     buttonText: "Create",
        //     media: {
        //         image: { originalPrice: 2799, price: 1699, duration: "30 Days", resolution: "1080 × 1080 px", format: "PNG / JPG", maxSize: "5 MB" },
        //         video: { originalPrice: 3299, price: 1999, duration: "30 Days", resolution: "1920 × 1080 px", format: "MP4", maxSize: "50 MB", length: "30 Seconds" }
        //     },
        //     features: ["Combo Menu Discounts", "Bundled Item Pricing", "Campaign Analytics"]
        // },

    ],

    digital: [
        {
            title: '32" Screen',
            goal: "branding",
            subGoal: "awareness",
            type: "Restaurant Display",
            icon: <ShoppingCartCheckoutOutlinedIcon />,
            buttonText: "Create",
            loopsPerDay: 50,          // 👈 NEW
            media: {
                image: { originalPrice: 2999, price: 1799, duration: "30 Days", timeDuration: "1 Minute", resolution: "1920 × 1080 px", format: "PNG / JPG", maxSize: "10 MB" },
                video: { originalPrice: 3999, price: 2399, duration: "30 Days", timeDuration: "1 Minute", resolution: "3840 × 2160 px", format: "MP4", maxSize: "100 MB", length: "1 Minute" }
            },
            features: ['32" Full HD Screen', "Restaurant Indoor Display", "1 Minute Display Duration", "Monthly Campaign"]
        },
        {
            title: '55" Screen',
            goal: "branding",
            subGoal: "awareness",
            type: "Shopping Mall Display",
            popular: true,
            icon: <DiamondOutlinedIcon />,
            buttonText: "Create",
            loopsPerDay: 50,         // 👈 NEW
            media: {
                image: { originalPrice: 4999, price: 2999, duration: "30 Days", timeDuration: "1 Minute", resolution: "3840 × 2160 px", format: "PNG / JPG", maxSize: "15 MB" },
                video: { originalPrice: 5999, price: 3599, duration: "30 Days", timeDuration: "1 Minute", resolution: "3840 × 2160 px", format: "MP4", maxSize: "150 MB", length: "1 Minute" }
            },
            features: ['55" 4K Display', "Shopping Mall Screens", "1 Minute Display Duration", "Prime Customer Reach"]
        },
        {
            title: '75" LED Video Wall',
            goal: "branding",
            subGoal: "awareness",
            type: "Premium Display",
            icon: <EmojiEventsOutlinedIcon />,
            buttonText: "Create",
            loopsPerDay: 50,         // 👈 NEW
            media: {
                image: { originalPrice: 6999, price: 4199, duration: "30 Days", timeDuration: "1 Minute", resolution: "7680 × 4320 px", format: "PNG / JPG", maxSize: "20 MB" },
                video: { originalPrice: 8999, price: 5399, duration: "30 Days", timeDuration: "1 Minute", resolution: "7680 × 4320 px", format: "MP4", maxSize: "250 MB", length: "1 Minute" }
            },
            features: ['75" LED Video Wall', "8K Display Support", "1 Minute Display Duration", "High Traffic Locations"]
        }
    ],

    combos: [
        {
            title: " In-App Popup",
            goal: "Combos",
            subGoal: "offers",
            type: "Combo Offer",
            icon: <CampaignOutlinedIcon />,
            buttonText: "Create",
            loopsPerDay: 100,
            media: {
                image: { originalPrice: 1799, price: 999, duration: "30 Days", resolution: "1080 × 1080 px", format: "JPG / PNG", maxSize: "5 MB" },
                video: { originalPrice: 2499, price: 1399, duration: "30 Days", resolution: "1920 × 1080 px", format: "MP4", maxSize: "50 MB", length: "30 Seconds" }
            },
            features: ["Combo Popup Advertisement", "Image & Video Support", "30 Days"]
        },
        {
            title: "Banner",
            goal: "Combos",
            subGoal: "offers",
            type: "Combo Offer",
            icon: <ViewCarouselOutlinedIcon />,
            buttonText: "Create",
            loopsPerDay: 150,
            media: {
                image: { originalPrice: 1799, price: 1099, duration: "30 Days", resolution: "1920 × 600 px", format: "PNG / JPG", maxSize: "5 MB" },
                video: { originalPrice: 2299, price: 1399, duration: "30 Days", resolution: "1720 × 600 px", format: "MP4", maxSize: "50 MB", length: "30 Seconds" }
            },
            features: ["Combo Homepage Banner", "Image & Video Support", "30 Days"]
        },
        {
            title: "Deals",
            goal: "Combos",
            subGoal: "offers",
            type: "Combo Offer",
            popular: true,
            icon: <LocalMallOutlinedIcon />,
            buttonText: "Create",
            loopsPerDay: 100,
            media: {
                image: { originalPrice: 2499, price: 1499, duration: "30 Days", resolution: "1080 × 1080 px", format: "PNG / JPG", maxSize: "5 MB" },
                video: { originalPrice: 2999, price: 1799, duration: "30 Days", resolution: "1920 × 1080 px", format: "MP4", maxSize: "50 MB", length: "30 Seconds" }
            },
            features: ["Combo Featured Deals", "Image & Video Support", "30 Days"]
        },
        {
            title: "Checkout",
            goal: "Combos",
            subGoal: "offers",
            type: "Combo Offer",
            icon: <ShoppingCartCheckoutOutlinedIcon />,
            buttonText: "Create",
            loopsPerDay: 100,
            media: {
                image: { originalPrice: 1999, price: 1099, duration: "30 Days", resolution: "1080 × 1080 px", format: "JPG / PNG", maxSize: "5 MB" },
                video: { originalPrice: 2999, price: 1699, duration: "30 Days", resolution: "1920 × 1080 px", format: "MP4", maxSize: "50 MB", length: "30 Seconds" }
            },
            features: ["Combo at Checkout Page", "Image & Video Support", "30 Days"]
        }
    ],
};

// 👇 NEW: controlledTab / hideOwnTabs let a parent (e.g. Overview's top tab bar)
// drive which category is shown, without this component drawing its own duplicate tabs.
const Pricingsectionparticular = ({
    feature,
    onCreateCampaign,
    hideParentBack,
    pricingMode,
    showParentBack,
    hideParentTabs,
    showParentTabs,
    controlledTab = null,   // 👈 NEW
    hideOwnTabs = false,    // 👈 NEW
}) => {
    const getDefaultTab = () => {
        if (controlledTab) return controlledTab; // 👈 NEW: parent-driven tab wins

        if (!feature) return "branding";

        switch (feature.title) {

            case "Branding Campaigns":
                return "branding";

            case "Lead Generation":
                return "leads";

            case "Digital Branding":
                return "digital";

            case "Percentage Discount":
                return "offers";

            case "Flat Discount":
                return "offers";

            case "Push Notifications":
                return "branding";

            case "Buy 1 Get 1":
                return "offers";

            case "WhatsApp Promotions":
                return "leads";

            case "Festival Offers":
                return "offers";

            case "Happy Hours":
                return "offers";

            case "Combo Offers":
                return "combos";
            default:
                return "branding";
        }
    };
    const [hidePricingSection, setHidePricingSection] = useState(false);
    const [activeTab, setActiveTab] = useState(getDefaultTab());
    const [mediaTypes, setMediaTypes] = useState({});
    const [leadPackage, setLeadPackage] = useState("100");
    const [showCreateCampaign, setShowCreateCampaign] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState(null);
    // const [pricingMode, setPricingMode] = useState("fixed"); // "fixed" | "custom"
    const [durationTypes, setDurationTypes] = useState({});

    const handleDurationChange = (cardKey, duration) => {
        setDurationTypes((prev) => ({
            ...prev,
            [cardKey]: duration,
        }));
    };
    // 👇 NEW: keep internal activeTab in sync whenever the parent-controlled tab changes
    useEffect(() => {
        if (controlledTab) {
            setActiveTab(controlledTab);
        }
    }, [controlledTab]);

    const getLoopsPerDayLabel = (plan) => {
        if (activeTab === "branding") {
            return plan.loopsPerDay ? `${plan.loopsPerDay} Loops/day` : null;
        }

        if (activeTab === "leads") {
            const match = plan.title.match(/\d+/);
            const totalLeads = match ? Number(match[0]) : 0;
            const perDay = Math.round(totalLeads / 30);
            return `~${perDay} Leads/day`;
        }

        return null;
    };
    const handleMediaTypeChange = (cardKey, isVideo) => {
        setMediaTypes((prev) => ({
            ...prev,
            [cardKey]: isVideo ? "video" : "image",
        }));
    };

    const getPrice = (plan, cardKey) => {
        let final, original;

        if (activeTab === "branding" || activeTab === "digital" || activeTab === "leads" || activeTab === "combos" || activeTab === "offers") {
            const currentMedia = mediaTypes[cardKey] || "image";
            const mediaData = currentMedia === "video" ? plan.media.video : plan.media.image;
            final = mediaData.price;
            original = mediaData.originalPrice;
        } else {
            final = plan.price;
            original = plan.originalPrice;
        }

        const currentDuration = durationTypes[cardKey] || "month";

        if (currentDuration === "day") {
            return {
                final: Math.max(1, Math.round(final / 30)),
                original: original ? Math.max(1, Math.round(original / 30)) : null,
                suffix: "/day",
            };
        }

        if (currentDuration === "year") {
            return {
                final: Math.round(final * 12 * 0.85),
                original: original ? original * 12 : Math.round(final * 12 * 1.15),
                suffix: "/yr",
            };
        }

        return { final, original, suffix: "/mo" };
    };

    if (showCreateCampaign) {
        return (
            <CreateCampaign
                selectedPlan={selectedPlan}
                selectedFeature={{
                    goal: selectedPlan?.goal,
                    subGoal: selectedPlan?.subGoal,
                    title: selectedPlan?.title,
                }}
                onBack={() => {
                    setShowCreateCampaign(false);
                    showParentBack?.();   // 👈 NEW
                    showParentTabs?.();   // 👈 NEW
                }}
            />
        );
    }



    return (
        <>{pricingMode === "fixed" && !hidePricingSection && (

            <section className="maamaasPricingWrapper">
                <div className="maamaasPricingContainer">




                    {/* Sub Header — hidden when a parent tab bar (hideOwnTabs) already drives activeTab */}

                    {!feature && !hideOwnTabs && (

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "left",
                                gap: "15px",
                                margin: "20px 0",
                                flexWrap: "wrap"
                            }}
                        >
                            {[
                                { id: "branding", label: "Branding" },
                                { id: "leads", label: "Leads" },
                                { id: "offers", label: "Offers" },
                                { id: "digital", label: "Digital Screens" },
                                { id: "combos", label: "Combos" }
                            ].map((tab) => (

                                <button
                                    key={tab.id}
                                    onClick={() => setActiveTab(tab.id)}
                                    style={{
                                        padding: "8px 18px",
                                        borderRadius: "20px",
                                        border: activeTab === tab.id ? "none" : "1px solid #d1d5db",
                                        background: activeTab === tab.id ? "#e66d33" : "#fff",
                                        color: activeTab === tab.id ? "#fff" : "#374151",
                                        cursor: "pointer",
                                        fontWeight: 600,
                                    }}
                                >
                                    {tab.label}
                                </button>

                            ))}
                        </div>

                    )}

                    <div className="maamaasPricingGrid">
                        {pricingPlans[activeTab]
                            .filter((plan) => {
                                if (!feature) return true;

                                switch (feature.title) {
                                    case "Branding Campaigns":
                                        return [
                                            "In-App Popup",
                                            "Banner",
                                            "Deals",
                                            "Checkout",
                                        ].includes(plan.title);

                                    case "Lead Generation":
                                        return plan.type === "Lead Generation";

                                    case "Digital Branding":
                                        return [
                                            '32" Screen',
                                            '55" Screen',
                                            '75" LED Video Wall',
                                        ].includes(plan.title);

                                    case "Flat Discount":
                                        return plan.title === "Coupons";

                                    case "Percentage Discount":
                                        return plan.title === "Menu Discounts";

                                    case "Festival Offers":
                                        return plan.title === "Coupons";

                                    case "Happy Hours":
                                        return plan.title === "Coupons";

                                    case "Buy 1 Get 1":
                                        return [
                                            "Buy 1 Get 1",
                                            "Buy 2 Get 1",
                                            "Buy 3 Get 1",
                                        ].includes(plan.title);

                                    case "WhatsApp Promotions":
                                        return plan.type === "Lead Generation";

                                    default:
                                        return true;
                                }
                            })
                            .map((plan, index) => {
                                const cardKey = `${activeTab}-${index}`;
                                const currentMedia = mediaTypes[cardKey] || "image";

                                return (
                                    <div
                                        key={index}
                                        className={`maamaasPricingCard ${plan.popular ? "maamaasPricingCardFeatured" : ""
                                            }`}
                                    >
                                        {plan.popular && (
                                            <div className="maamaasPricingPopularTag">
                                                ★ Most Popular
                                            </div>
                                        )}

                                        <div className="maamaasPricingCardTop">
                                            <div className="maamaasPricingIconBox">
                                                {plan.icon}
                                            </div>
                                            <h4
                                                className="maamaasPricingPlanName"
                                                style={{
                                                    margin: 0,
                                                    fontSize: "20px",
                                                    fontWeight: "700",
                                                    color: "#1f2937",
                                                }}
                                            >
                                                {plan.title}
                                            </h4>
                                            {/* <span className="maamaasPricingType">
                                            {plan.type}
                                        </span> */}
                                        </div>

                                        {/* Title */}


                                        {/* Image / Video Buttons */}
                                        {(activeTab === "branding" || activeTab === "digital" || activeTab === "leads" || activeTab === "combos" || activeTab === "offers") && (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    gap: "10px",
                                                    marginBottom: "15px",
                                                    marginTop: "10px"
                                                }}
                                            >
                                                <Button
                                                    variant={
                                                        currentMedia === "image"
                                                            ? "contained"
                                                            : "outlined"
                                                    }
                                                    size="small"
                                                    onClick={() =>
                                                        handleMediaTypeChange(cardKey, false)
                                                    }
                                                    sx={{
                                                        textTransform: "none",
                                                        borderRadius: "20px",
                                                        minWidth: "90px",
                                                        backgroundColor:
                                                            currentMedia === "image"
                                                                ? "#e66d33"
                                                                : "transparent",
                                                        borderColor: "#e66d33",
                                                        color:
                                                            currentMedia === "image"
                                                                ? "#fff"
                                                                : "#e66d33",
                                                        "&:hover": {
                                                            backgroundColor:
                                                                currentMedia === "image"
                                                                    ? "#d85f28"
                                                                    : "#fff3ec",
                                                            borderColor: "#e66d33",
                                                        },
                                                    }}
                                                >
                                                    🖼 Image
                                                </Button>

                                                <Button
                                                    variant={
                                                        currentMedia === "video"
                                                            ? "contained"
                                                            : "outlined"
                                                    }
                                                    size="small"
                                                    onClick={() =>
                                                        handleMediaTypeChange(cardKey, true)
                                                    }
                                                    sx={{
                                                        textTransform: "none",
                                                        borderRadius: "20px",
                                                        minWidth: "90px",
                                                        backgroundColor:
                                                            currentMedia === "video"
                                                                ? "#e66d33"
                                                                : "transparent",
                                                        borderColor: "#e66d33",
                                                        color:
                                                            currentMedia === "video"
                                                                ? "#fff"
                                                                : "#e66d33",
                                                        "&:hover": {
                                                            backgroundColor:
                                                                currentMedia === "video"
                                                                    ? "#d85f28"
                                                                    : "#fff3ec",
                                                            borderColor: "#e66d33",
                                                        },
                                                    }}
                                                >
                                                    🎥 Video
                                                </Button>
                                            </div>
                                        )}

                                        {/* Day / Month / Year selector — shown on every card */}
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                gap: "8px",
                                                marginBottom: "15px",
                                            }}
                                        >
                                            {[
                                                { id: "day", label: "Day" },
                                                { id: "month", label: "Month" },
                                                { id: "year", label: "Year" },
                                            ].map((d) => {
                                                const isActive = (durationTypes[cardKey] || "month") === d.id;
                                                return (
                                                    <Button
                                                        key={d.id}
                                                        variant={isActive ? "contained" : "outlined"}
                                                        size="small"
                                                        onClick={() => handleDurationChange(cardKey, d.id)}
                                                        sx={{
                                                            textTransform: "none",
                                                            borderRadius: "20px",
                                                            minWidth: "72px",
                                                            backgroundColor: isActive ? "#e66d33" : "transparent",
                                                            borderColor: "#e66d33",
                                                            color: isActive ? "#fff" : "#e66d33",
                                                            "&:hover": {
                                                                backgroundColor: isActive ? "#d85f28" : "#fff3ec",
                                                                borderColor: "#e66d33",
                                                            },
                                                        }}
                                                    >
                                                        {d.label}
                                                    </Button>
                                                );
                                            })}
                                        </div>
                                        <div
                                            style={{
                                                margin: "15px 0",
                                            }}
                                        >
                                        </div>

                                        {/* {(() => {
                                            const { final, original, suffix } = getPrice(plan, cardKey);

                                            return (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        alignItems: "baseline",
                                                        justifyContent: "center",
                                                        gap: "8px",
                                                    }}
                                                >
                                                    {original && original > final && (
                                                        <span
                                                            style={{
                                                                fontSize: "30px",
                                                                color: "#9ca3af",
                                                                textDecoration: "line-through",
                                                                fontWeight: 500,
                                                            }}
                                                        >
                                                            ₹{original}
                                                        </span>
                                                    )}

                                                    <div
                                                        className="maamaasPricingAmountRow"
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "baseline",
                                                            gap: "2px",
                                                        }}
                                                    >
                                                        <span className="maamaasPricingCurrency">₹</span>
                                                        <span className="maamaasPricingAmount">{final}</span>
                                                        <span className="maamaasPricingMonth">{suffix}</span>
                                                    </div>
                                                </div>
                                            );
                                        })()} */}


                                        {/* Resolution + Loops + Leads Per Day */}
                                        {(activeTab === "branding" || activeTab === "digital" || activeTab === "leads" || activeTab === "combos") && (
                                            <div className="mediaSpecs">
                                                <ul className="maamaasPricingFeatureList">
                                                    {(activeTab === "branding" || activeTab === "digital" || activeTab === "leads" || activeTab === "combos") && (
                                                        <li>
                                                            <CheckCircleRoundedIcon />
                                                            Resolution :
                                                            {currentMedia === "image"
                                                                ? plan.media.image.resolution
                                                                : plan.media.video.resolution}
                                                        </li>
                                                    )}

                                                    {(activeTab === "branding" || activeTab === "digital" || activeTab === "leads") && plan.loopsPerDay && (
                                                        <li>
                                                            <CheckCircleRoundedIcon />
                                                            Loops : {plan.loopsPerDay}/day
                                                        </li>
                                                    )}

                                                    {activeTab === "leads" && (
                                                        <li>
                                                            <CheckCircleRoundedIcon />
                                                            Leads Per Day : ~{Math.round((plan.title.match(/\d+/)?.[0] || 0) / 30)}
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                        )}

                                        {/* Features */}
                                        <ul className="maamaasPricingFeatureList">
                                            {plan.features.map((feature, idx) => (
                                                <li key={idx}>
                                                    <CheckCircleRoundedIcon />
                                                    {feature}
                                                </li>
                                            ))}
                                        </ul>
                                        <button
                                            className="maamaasPricingButton"
                                            onClick={() => {

                                                const { final } = getPrice(plan, cardKey); // ✅ ADD — get the actual displayed price (image/video + day/month/year adjusted)

                                                const planData = {
                                                    category: activeTab,
                                                    title: plan.title,
                                                    plan,
                                                    goal: plan.goal,
                                                    subGoal: plan.subGoal,
                                                    durationUnit: durationTypes[cardKey] || "month",
                                                    price: final, // ✅ ADD — this was the missing piece breaking the investment calculation
                                                };



                                                setSelectedPlan(planData);

                                                hideParentBack?.();

                                                hideParentTabs?.();
                                                setShowCreateCampaign(true);
                                            }}
                                        >
                                            {plan.buttonText}
                                        </button>
                                    </div>
                                );
                            })}
                    </div>
                </div>
            </section>
        )}
            {pricingMode === "custom" && (
                <ParticularsectionBuilder
                    selectedPlan={selectedPlan}
                    activeTab={activeTab}
                    feature={feature}
                    hidePricingSection={() => setHidePricingSection(true)}
                    hideParentBack={hideParentBack}
                    hideParentTabs={hideParentTabs}
                />
            )}
        </>
    );

};

export default Pricingsectionparticular;